import { Module } from 'vuex'
import { ImportantDocumentState, state } from './state'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { RootState } from '@/app/common/types/root-state.type'

export const importantDocumentStore: Module<ImportantDocumentState, RootState> = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
